module.exports = __webpack_public_path__ + "img/37card-logo.70c6a92f.png";